<template>
  <div class="ucrs-property__lightbox">
    <div class="flex justify-end pb-5">
      <div class="ucrs-modal__close" @click="$emit('close')"></div>
    </div>
    <ClientOnly>
      <Swiper
        :options="swiperOptions"
        navigation
        overlay-vertical
        nav-position="white-large"
        arrows-color="white"
      >
        <div
          v-for="(img, index) in images"
          :key="`PropertyLightbox_${index}`"
          class="swiper-slide flex justify-center items-center"
        >
          <div class="ucrs-property__lightbox-imageWrapper">
            <NuxtImg
              class="ucrs-property__lightbox-image"
              :src="$utilities.imgAlias(img.src)"
              :alt="`${alt} ${index + 1}`"
              loading="lazy"
              format="webp"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
      </Swiper>
    </ClientOnly>
  </div>
</template>

<script>
import Swiper from '~/components/Swiper.vue'

export default {
  components: {
    Swiper,
  },
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
    alt: {
      type: String,
      default: '',
    },
    startAt: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    swiperOptions() {
      const options = {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        spaceBetween: 20,
        loop: this.images.length > 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        initialSlide: this.startAt,
      }
      return options
    },
  },
}
</script>

<style lang="postcss">
.ucrs-property {
  &__lightbox {
    @apply relative pt-6;
  }

  &__lightbox-imageWrapper {
    @apply inline-block rounded;
  }

  &__lightbox-image {
    @apply rounded object-contain max-h-[calc(100vh-7rem)];
  }
}
</style>
